import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing,
} from '../../../theme';

export const StyledHowItem = styled.li`
  break-inside: avoid;
  page-break-inside: avoid;
  color: ${color('text_subtle')};
  font-size: ${fontSize('sm')};
  line-height: 1.43;
  margin-bottom: ${spacing('xl')};
  position: relative;

  &::before {
    counter-increment: howItem;
    content: '0' counter(howItem);
    display: inline-block;
    color: ${color('navy_500')};
    font-size: ${fontSize('xs')};
    line-height: 1;
    font-weight: ${fontWeight('extraBold')};
    margin-bottom: ${spacing('md')};
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 22px;
    left: 0;
    width: 15px;
    height: ${spacing('xs2')};
    background-color: ${color('navy_200')};
  }

  p {
    margin: 0;
  }
`;

export const StyledHowItemTitle = styled.h3`
  font-family: ${fontFamily('display')};
  color: ${color('text_default')};
  font-size: ${fontSize('xl3')};
  font-weight: ${fontWeight('light')};
  text-transform: uppercase;
  line-height: 1;
  margin-top: 0;
  margin-bottom: ${spacing('xs')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl4')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl6')};
  }
`;
